import { constructEnum } from '@/lib/enum';

export default constructEnum('InsufficientReviewLengthActionType', {
  SHOW_ALERT: 10,
  DISABLE_SAVE: 20,
  DO_NOTHING: 30
});
